/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CreateCollectionRequest from '../model/CreateCollectionRequest';
import CreateProjectRequest from '../model/CreateProjectRequest';
import GetCollectionResponse from '../model/GetCollectionResponse';
import GetProjectResponse from '../model/GetProjectResponse';
import ProjectInProjectList from '../model/ProjectInProjectList';

/**
* Project service.
* @module endpoints/ProjectApi
* @version 2.8.0
*/
export default class ProjectApi {

    /**
    * Constructs a new ProjectApi. 
    * @alias module:endpoints/ProjectApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Create a new collection in an user's project.
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {module:model/CreateCollectionRequest} createCollectionRequest Create collection input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetCollectionResponse} and HTTP response
     */
    createCollectionWithHttpInfo(userId, projectId, createCollectionRequest) {
      let postBody = createCollectionRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createCollection");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling createCollection");
      }
      // verify the required parameter 'createCollectionRequest' is set
      if (createCollectionRequest === undefined || createCollectionRequest === null) {
        throw new Error("Missing the required parameter 'createCollectionRequest' when calling createCollection");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = GetCollectionResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/collections', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create a new collection in an user's project.
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {module:model/CreateCollectionRequest} createCollectionRequest Create collection input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetCollectionResponse}
     */
    createCollection(userId, projectId, createCollectionRequest) {
      return this.createCollectionWithHttpInfo(userId, projectId, createCollectionRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Create a new user's project
     * @param {String} userId Id of the user
     * @param {module:model/CreateProjectRequest} createProjectRequest Create project input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetProjectResponse} and HTTP response
     */
    createProjectWithHttpInfo(userId, createProjectRequest) {
      let postBody = createProjectRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createProject");
      }
      // verify the required parameter 'createProjectRequest' is set
      if (createProjectRequest === undefined || createProjectRequest === null) {
        throw new Error("Missing the required parameter 'createProjectRequest' when calling createProject");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = GetProjectResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create a new user's project
     * @param {String} userId Id of the user
     * @param {module:model/CreateProjectRequest} createProjectRequest Create project input
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetProjectResponse}
     */
    createProject(userId, createProjectRequest) {
      return this.createProjectWithHttpInfo(userId, createProjectRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Delete collection
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} collectionName Name of the collection
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    deleteCollectionWithHttpInfo(userId, projectId, collectionName) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling deleteCollection");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling deleteCollection");
      }
      // verify the required parameter 'collectionName' is set
      if (collectionName === undefined || collectionName === null) {
        throw new Error("Missing the required parameter 'collectionName' when calling deleteCollection");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId,
        'collectionName': collectionName
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}/collections/{collectionName}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Delete collection
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @param {String} collectionName Name of the collection
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    deleteCollection(userId, projectId, collectionName) {
      return this.deleteCollectionWithHttpInfo(userId, projectId, collectionName)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Delete project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    deleteProjectWithHttpInfo(userId, projectId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling deleteProject");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling deleteProject");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Delete project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    deleteProject(userId, projectId) {
      return this.deleteProjectWithHttpInfo(userId, projectId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetProjectResponse} and HTTP response
     */
    getProjectWithHttpInfo(userId, projectId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getProject");
      }
      // verify the required parameter 'projectId' is set
      if (projectId === undefined || projectId === null) {
        throw new Error("Missing the required parameter 'projectId' when calling getProject");
      }

      let pathParams = {
        'userId': userId,
        'projectId': projectId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetProjectResponse;
      return this.apiClient.callApi(
        '/users/{userId}/projects/{projectId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get user's project
     * @param {String} userId Id of the user
     * @param {String} projectId Id of the project
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetProjectResponse}
     */
    getProject(userId, projectId) {
      return this.getProjectWithHttpInfo(userId, projectId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get user's project list
     * @param {String} userId Id of the user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ProjectInProjectList>} and HTTP response
     */
    getProjectsWithHttpInfo(userId) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getProjects");
      }

      let pathParams = {
        'userId': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ProjectInProjectList];
      return this.apiClient.callApi(
        '/users/{userId}/projects', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get user's project list
     * @param {String} userId Id of the user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ProjectInProjectList>}
     */
    getProjects(userId) {
      return this.getProjectsWithHttpInfo(userId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
